import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useEffect } from 'react';
/**
 * C1 — Portal Home
 * Two-path entry: existing account holders log in, everyone else starts a guest booking.
 * Redirects logged-in users to their role-appropriate dashboard.
 */
export default function PortalHome() {
    const { user, role, loading } = useAuth();
    const navigate = useNavigate();
    // Redirect already-authenticated users straight to their area
    useEffect(() => {
        if (loading || !user)
            return;
        if (role === 'admin')
            navigate('/admin', { replace: true });
        else if (role === 'member')
            navigate('/portal', { replace: true });
    }, [user, role, loading, navigate]);
    if (loading)
        return null;
    return (_jsxs("div", { className: "portal-home", children: [_jsxs("header", { children: [_jsx("img", { src: "/images/logo.png", alt: "Springfield Dog Centre", className: "h-24 w-auto mx-auto mb-4" }), _jsx("p", { children: "Professional dog day care near Selby" })] }), _jsx("main", { children: _jsxs("div", { className: "path-grid", children: [_jsxs("div", { className: "path-card", children: [_jsx("h2", { children: "Daycare Members Booking" }), _jsx("p", { children: "Log in to book and manage your daycare bookings, update your dogs' details, or book any other additional services, including our new Enrichment services as well." }), _jsx("button", { onClick: () => navigate('/login'), children: "Log in" })] }), _jsxs("div", { className: "path-card", children: [_jsx("h2", { children: "Book non-daycare services" }), _jsx("p", { children: "If you are new to Springfield DogCentre, you can book your assessment here." }), _jsx("a", { href: "https://springfielddogcentre.co.uk/assessment-form/", children: "Book Assessment" })] })] }) })] }));
}
